import { useFormikContext, Field, FieldProps } from 'formik';
import { FormikInputText } from 'components/forms/formik/FormikInputText';
import { FormikCheckbox } from 'components/forms/formik/FormikCheckbox';
import { ReferentialDropdown } from 'features/referentials/components/ReferentialDropdown';
import { ReferentialKey } from 'api/referential';
import { SurveyFormFieldNames } from './SurveyFormFieldNames';
import { SurveyFormValues } from './SurveyFormValues';
import clsx from 'clsx';

interface SurveyLayoutProps {
  isEditMode?: boolean;
}

export const SurveyLayout: React.FC<SurveyLayoutProps> = ({ isEditMode = false }) => {
  const { values } = useFormikContext<SurveyFormValues>();

  return (
    <div className="flex flex-col gap-6 p-4">
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <FormikInputText
          name={SurveyFormFieldNames.Name}
          label="Nom du questionnaire"
          placeholder="Ex: Questionnaire Situation Assuré"
          required
        />

        <FormikInputText
          name={SurveyFormFieldNames.Code}
          label="Code"
          placeholder="Ex: QUEST001"
          required
          disabled={isEditMode}
        />
      </div>

      <Field name={SurveyFormFieldNames.Description}>
        {({ field, meta }: FieldProps) => (
          <div className="flex flex-col gap-1">
            <label className="text-sm font-medium text-gray-700">Description</label>
            <textarea
              {...field}
              rows={3}
              placeholder="Description du questionnaire..."
              className={clsx(
                'w-full px-3 py-2 border rounded-md text-sm resize-none',
                'focus:outline-none focus:ring-2 focus:ring-primary/20 focus:border-primary',
                meta.touched && meta.error ? 'border-red-500' : 'border-gray-300'
              )}
            />
            {meta.touched && meta.error && (
              <span className="text-xs text-red-500">{meta.error}</span>
            )}
          </div>
        )}
      </Field>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <ReferentialDropdown
          name={SurveyFormFieldNames.ContextId}
          label="Contexte"
          referentialKey={ReferentialKey.QuestionsContexts}
          placeholder="Sélectionner un contexte"
          required
        />

        <ReferentialDropdown
          name={SurveyFormFieldNames.BranchId}
          label="Branche"
          referentialKey={ReferentialKey.Branch}
          placeholder="Sélectionner une branche (optionnel)"
        />
      </div>

      <div className="border-t pt-4">
        <FormikCheckbox
          name={SurveyFormFieldNames.IsActive}
          label="Questionnaire actif"
        />
      </div>
    </div>
  );
};
